<template>
  <div>
    <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
  </div>
</template>

<script>
import { ApiUrl } from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";

import columns from '../datatable/columns';
import actionsColumn from '../components/actions-column'


export default {
  name: 'money-request-without-manage',
  props: {
    query: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      datatableProps: {
        id: 'datatable',
        data: {
          type: 'remote',
          source: {
            read: {
              url: ApiUrl.path('money-request/fetch'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function (res) {
                return res.data.data;
              },
              params: {
                query: this.query,
              },
            },
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn,
      },
    };
  },
  methods: {
    reload() {
      if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload();
      }
    },
  },
};
</script>
